module.exports = __webpack_public_path__ + "assets/images/users-plus-purple.svg?cebec9557550b13f0fd900b4798d6130";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/users-plus-purple.svg
// module id = 623
// module chunks = 0